import { name, vat, slug, email, companyType } from "./validations";

export const CompanyValidate = {
  name,
  vat,
  slug,
  type: companyType,
  contact_mail: email,
};
